<div class="flex flex-col items-center gap-8 w-full max-w-4xl mx-auto py-8">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">
        <!-- Account Selection Card -->
        <p-card header="Account Selection" styleClass="w-full">
            <form [formGroup]="mergeForm" class="flex flex-col gap-6" autocomplete="off"
                (submit)="$event.preventDefault()">
                <div class="flex flex-col gap-2">
                    <label for="sourceID" class="font-medium">Merge this account:</label>
                    <input id="sourceID" name="sourceID" type="number" min="1" max="9999999"
                        placeholder="This account will be deleted!" class="p-inputtext w-full no-spin"
                        formControlName="sourceId" />
                    <div *ngIf="mergeForm.get('sourceId')?.invalid && mergeForm.get('sourceId')?.touched"
                        class="text-red-500 text-xs">
                        Enter a valid source account ID.
                    </div>
                </div>
                <div class="flex flex-col gap-2">
                    <label for="destID" class="font-medium">Into this account:</label>
                    <input id="destID" name="destID" type="number" min="1" max="9999999"
                        placeholder="This account will be kept." class="p-inputtext w-full no-spin"
                        formControlName="destId" />
                    <div *ngIf="mergeForm.get('destId')?.invalid && mergeForm.get('destId')?.touched"
                        class="text-red-500 text-xs">
                        Enter a valid destination account ID.
                    </div>
                </div>
                <div class="flex justify-end">
                    <button type="button" class="p-button p-component" [disabled]="!mergeForm.valid || loading()"
                        (click)="selectAccounts()">Select Accounts</button>
                </div>
            </form>
        </p-card>

        <!-- Merge Confirmation Card -->
        <p-card header="Merge Confirmation" styleClass="w-full flex flex-col justify-center items-center">
            <div *ngIf="confirmationVisible(); else noAccounts" class="w-full">
                <div class="flex flex-col gap-4">
                    <div>
                        <span class="font-medium text-gray-700">Merge this account:</span><br>
                        <span class="text-lg">
                            {{ sourceGroupname() }}
                        </span>
                    </div>
                    <div>
                        <span class="font-medium text-gray-700">Into this account:</span><br>
                        <span class="text-lg">
                            {{ destGroupname() }}
                        </span>
                    </div>
                    <div class="flex justify-end">
                        <button type="button" class="p-button p-component" [disabled]="loading()"
                            (click)="confirmMerge()">Confirm Merge</button>
                    </div>
                </div>
            </div>
            <ng-template #noAccounts>
                <p>No accounts selected.</p>
            </ng-template>
        </p-card>
    </div>

    <!-- Merge Process Card -->
    <div class="w-full">
        <p-card header="Merge Process" styleClass="w-full">
            <p>When you merge two groups, here's what happens behind the scenes:</p>
            <ol class="list-decimal list-inside mt-2 space-y-1">
                <li>The "Merge this account" group will be deleted. Poof. Gone.</li>
                <li>
                    The <strong>Pelican Account Info</strong>, <strong>Recruiting Info</strong>, and <strong>Merged
                        NetSuite Info</strong> information from the deleted account will be discarded.
                </li>
                <li>All scheduled activities and activity notes from the deleted account will be merged into the
                    remaining account.</li>
                <li>All past/future trips, potential trips, donations, potential gifts, and group contacts from the deleted account will be
                    transferred into the remaining account.</li>
            </ol>
        </p-card>
    </div>
</div>